<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <router-link to="/addvalidationCheck" class=" btn btn-success transition border-0 lh-1 fw-medium">
                + Ajouter une validation Check </router-link>
            <div class="d-flex align-items-center">

                <form class="search-box position-relative me-15" @submit.prevent="rechercher">
                    <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
                        class="form-control shadow-none text-black rounded-0 border-0"
                        placeholder="Rechercher une validation Check" />
                    <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                        <i class="flaticon-search-interface-symbol"></i>
                    </button>
                </form>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Titre
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Code technique unique du contrôle
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Description
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Type de contrôle
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Résultat du contrôle
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Niveau de sévérité du contrôle en cas d’échec
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Commentaire
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date et heure ou le contrôle a été réalisé ou mis à jour.
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Validation Tasks
                            </th>
                            <th scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                                Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(validationCheck, index) in validationChecks" :key="index">
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationCheck?.title }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationCheck?.check_code }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationCheck?.description }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getCheckType(validationCheck.check_type)"></span>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getResultBadgeClass(validationCheck.result)"></span>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getSeverityBadgeClass(validationCheck.severity)"></span>

                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationCheck.comments }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(validationCheck.checked_at) }}
                            </td>
                            <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ validationCheck.validationtasks.status }}
                            </td> -->
                            <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                                <div class="dropdown">
                                    <span class="badge text-white bg-primary fs-15 dropdown-toggle"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        Actions
                                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                                    </span>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <router-link
                                                :to="{ name: 'EditValidationCheckPage', params: { id: validationCheck.id } }"
                                                class="dropdown-item d-flex align-items-center"><i
                                                    class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier</router-link>
                                        </li>
                                        <li>
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);"
                                                @click="suppression(validationCheck.id, validationCheck, 'validationc', 'validationCheck')">
                                                <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                                                Supprimer
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">

                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
                    @paginate="handlePaginate" />

            </div>
        </div>
    </div>
</template>
<script lang="ts">

import { defineComponent, onMounted, ref, watch, computed } from "vue";

import ApiService from "../../services/ApiService";
import { format_date, suppression, error } from "../../utils/utils";
import axios from 'axios';
import Swal from "sweetalert2";
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";
import { TypeFretPaiement } from "@/models/TypeFretPaiement";
import AddModalValidationTask from "./AddModalValidationTask.vue";
import { ValidationTask } from "@/models/ValidationTask";
import AddModalValidationCheck from "./AddModalValidationCheck.vue";
import { ValidationCheck } from "@/models/ValidationCheck";
import { formatDate } from "@fullcalendar/core";

export default defineComponent({
    name: "ListeValidationTask",
    components: {
        PaginationComponent
    },
    setup: () => {
        // const modules = {

        // };

        const validationChecks = ref<Array<ValidationCheck>>([]);
        const validationCheck = ref<ValidationCheck>();
        const addModalValidationCheckRef = ref<null | HTMLElement>(null);
        const selectedItem = ref(0);
        const format = (d) => d ? formatDate(d) : "";

        // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
            try {
                page.value = page_;
                getAllValidationCheck(page_, limit_);
            } catch (error) {
                //
            }
        };

        function rechercher() {
            getAllValidationCheck(page.value, limit.value, searchTerm.value);
        }
        // END PAGINATE



        function getAllValidationCheck(page = 1, limi = 10, searchTerm = '') {
            // const user = JwtService.getUser();
            // console.log("user:", user);
            // if (!user) return error("Utilisateur non connecté");
            // const userId = user.userId.replace(/\/+$/, '').trim();
            // if (!userId) return error("Utilisateur non connecté")
            return ApiService.get(`validationcs?page=${page}&limit=${limi}&searchTerm=${searchTerm}&`)
                .then(({ data }) => {
                    console.log("donneeeee",data);
                    validationChecks.value = data.data.data;
                    totalPages.value = data.data.totalPages;
                    limit.value = data.data.limit;
                    totalElements.value = data.data.totalElements;
                })
                .catch(({ response }) => {
                    error(response.data.message)
                });
        }

        onMounted(() => {
            getAllValidationCheck();
        });

        function moddifier(EditValidationCheck: ValidationCheck) {
            validationCheck.value = EditValidationCheck;
            selectedItem.value = EditValidationCheck.id;
        }
        const recharger = () => {
            getAllValidationCheck();
        };

        const privileges = ref<Array<string>>(JwtService.getPrivilege());

        const checkPermission = (name) => {
            return privileges.value.includes(name);
        }
        const getCheckType = (value: string | null | undefined): string => {
            if (!value) {
                return '<span class="badge bg-secondary text-white">Aucun</span>';
            }

            switch (value) {
                case 'MANUAL':
                    return '<span class="badge bg-info text-white">Manuel</span>';

                case 'AUTOMATIC':
                    return '<span class="badge bg-success text-white">Automatique</span>';

                default:
                    return `<span class="badge bg-light text-dark">${value}</span>`;
            }
        };

        const getResultBadgeClass = (value: string | null | undefined): string => {
            if (!value) {
                return '<span class="badge bg-secondary text-white">Inconnu</span>';
            }

            switch (value) {
                case 'PENDING':
                    return '<span class="badge bg-warning text-dark">En attente</span>';

                case 'PASSED':
                    return '<span class="badge bg-success text-white">Validé</span>';

                case 'FAILED':
                    return '<span class="badge bg-danger text-white">Échoué</span>';

                case 'NOT_APPLICABLE':
                    return '<span class="badge bg-secondary text-white">Non applicable</span>';

                default:
                    return `<span class="badge bg-light text-dark">${value}</span>`;
            }
        };
        const getSeverityBadgeClass = (value: string | null | undefined): string => {
            if (!value) {
                return '<span class="badge bg-secondary text-white">Inconnu</span>';
            }

            switch (value) {
                case 'INFO':
                    return '<span class="badge bg-primary text-white">Information</span>';

                case 'WARNING':
                    return '<span class="badge bg-warning text-dark">Avertissement</span>';
                // text-dark = très lisible sur fond jaune

                case 'BLOCKING':
                    return '<span class="badge bg-danger text-white">Bloquant</span>';

                default:
                    return `<span class="badge bg-light text-dark">${value}</span>`;
            }
        };
        return {
            // modules,
            format,
            checkPermission,
            selectedItem,
            validationChecks,
            recharger,
            suppression,
            moddifier,
            page,
            totalPages,
            limit,
            totalElements,
            getAllValidationCheck,
            handlePaginate,
            searchTerm,
            rechercher, getCheckType, getResultBadgeClass,
            getSeverityBadgeClass
        };
    },
});
</script>
